import { BehaviorSubject } from "rxjs";
import { DayTheme } from "../Config/Theme";
import { THEME_TYPE } from "../Types/CommonTypes";
import PersistStorage from "../../../Utils/PersistStorage";

const theme$ = new BehaviorSubject<THEME_TYPE>(DayTheme);

const persistStorage = new PersistStorage("appThemeState", theme$);
persistStorage.init();
export default theme$;
